import { Component, OnInit, TemplateRef, Input, ViewChild, OnDestroy } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { CpmService } from '../../service/cpm.service';
import { ActivatedRoute } from '@angular/router';
import { StoreService } from '../../service/store.service';
import { Subscription } from 'rxjs/Subscription';

import { environment } from '../../../environments/environment';
@Component({
	selector: 'app-company-header',
	templateUrl: './company-header.component.html',
	styleUrls: ['./company-header.component.scss'],
})
export class CompanyHeaderComponent implements OnInit, OnDestroy {
	@Input() exportFunctions: Map<String, Function>;
	@Input() printPage;
	@ViewChild('template') template: TemplateRef<any>;
	@Input() isFullFactSheet;
	@Input() btnExportId;
	@Input() blockId;
	modalRef: BsModalRef;
	companyForm: FormGroup;
	isCompanyHeader = true;
	effectiveName = 'Effective date';
	oldName;
	newName;
	finAlert;
	changedHistorys;
	cgScore;
	cgNonScore;
	subscription: Subscription;
	securityStatistic;
	type = '';
	companyProfile: any;
	securitySymbol;
	signPostin = {
		sign: '',
		cashBalance: '',
	};
	indexThsi;
	globalIndex;
	changeCompanyName = [];
	changeSector = [];
	changeSymbol = [];
	companyNameEng;
	companyNameThai;
	potentialGroup;
	indexComposition;
	indexCompositionStr;
	marketCap;
	lastPriceClose;
	pbv;
	pe;
	par;
	industryName;
	sectorName;
	freeFloatAlert;
	pdf;
	cashBalanceLevel;

	constructor(private modalService: BsModalService, private cpmService: CpmService, private store: StoreService) {}

	ngOnInit() {
		this.setCompanyProfile();
	}

	getDecoration(type) {
		let length = 0;
		switch (type) {
			case 'company':
				length = this.changeCompanyName.length;
				break;
			case 'sector':
				length = this.changeSector.length;
				break;
			case 'symbol':
				length = this.changeSymbol.length;
				break;
		}
		if (length > 0) {
			return true;
		} else {
			return false;
		}
	}

	onClickOpenModal(type) {
		this.changedHistorys = [];
		this.type = type;
		if (type === 'company') {
			this.companyProfile.changeCompanyName.map(company => {
				const companyObj = {
					effectiveDate: company.effectiveDate,
					oldName: company.oldNameEng,
					newName: company.newNameEng,
				};
				this.changedHistorys.push(companyObj);
			});
			this.oldName = 'Old company name';
			this.newName = 'New company name';
		} else if (type === 'sector') {
			this.changedHistorys = this.companyProfile.changeSector;
			this.oldName = 'Old industry/sector';
			this.newName = 'New industry/sector';
		} else {
			this.changedHistorys = this.companyProfile.changeSymbol;
			this.oldName = 'Old symbol';
			this.newName = 'New symbol';
		}

		this.openModal(this.template);
	}

	openModal(template: TemplateRef<any>) {
		this.modalRef = this.modalService.show(template, Object.assign({}, { class: 'modal-lg' }));
	}
	closeModal() {
		this.modalRef.hide();
	}

	displaySign(sign) {
		if (sign.length === 0) {
			return false;
		} else {
			return true;
		}
	}
	displaycashBalance(sign) {
		if (isNaN(sign)) {
			return false;
		} else {
			return true;
		}
	}

	setCompanyProfile() {
		this.subscription = this.store.getSecurityProfileNewResultObservable().subscribe(response => {
			if (!response) {
				return;
			}
			this.securitySymbol = response['securitySymbol'];
			this.companyProfile = response;
			this.changeCompanyName = this.companyProfile.changeCompanyName;
			this.changeSector = this.companyProfile.changeSector;
			this.changeSymbol = this.companyProfile.changeSymbol;
			this.companyNameEng = this.companyProfile.companyNameEng;
			this.companyNameThai = this.companyProfile.companyNameThai;
			this.potentialGroup = this.companyProfile.potentialGroup;
			this.indexComposition = this.companyProfile.indexComposition;
			this.par = this.companyProfile.par;
			this.industryName = this.companyProfile.industryName;
			this.sectorName = this.companyProfile.sectorName;
			const indexComposition = [];
			this.companyProfile.indexComposition.map(obj => {
				indexComposition.push(obj);
			});
			if (indexComposition.length == 0) this.indexCompositionStr = '-';
			else this.indexCompositionStr = indexComposition.join(', ');
			this.cgScore = Array(Number(this.companyProfile.cgScore));
			this.cgNonScore = Array(5 - Number(this.companyProfile.cgScore));
			const globalIndexComposition = [];
			this.companyProfile.globalIndexComposition.map(obj => {
				globalIndexComposition.push(obj);
			});
			if (globalIndexComposition.length == 0) this.globalIndex = '';
			else this.globalIndex = globalIndexComposition.join(', ');
			const signList = [];
			let cashBalance;

			this.cpmService.getSignCurrent(this.securitySymbol).then(
				sign => {
					sign.map(signType => {
						isNaN(Number(signType.type))
							? signList.push(signType.type)
							: (cashBalance = Number(signType.type));
					});
					this.signPostin.sign = signList.join(', ');
					this.signPostin.cashBalance = cashBalance;
					this.cashBalanceLevel = 'Cash balance level ' + this.signPostin.cashBalance;
				},
				err => {}
			);

			this.cpmService.getFinancialAlertBySecuritySymbol(this.securitySymbol).then(
				financial => {
					this.finAlert = financial.financialAlert;
				},
				err => {}
			);

			this.cpmService.getSecurityStatistic(this.securitySymbol).then(
				success => {
					this.securityStatistic = success;
					this.marketCap = this.securityStatistic.marketCap;
					this.lastPriceClose = this.securityStatistic.lastPriceClose;
					this.pbv = this.securityStatistic.pbv;
					this.pe = this.securityStatistic.pe;
				},
				err => {}
			);

			this.cpmService.getAdjustedFreefloatByRoundAndSecuritySymbol(3, this.securitySymbol).then(
				success => {
					if (success.notice) {
						this.freeFloatAlert = true;
					} else {
						this.freeFloatAlert = false;
					}
				},
				err => {}
			);
		});
	}

	checkPoptencialGroup(potentialGroup) {
		switch (potentialGroup) {
			case 'A':
				return 'บจ. ที่อยู่ทั้งใน MSCI Standard, MSCI ESG และ DJSI แล้ว';
			case 'B':
				return 'บจ. ที่ควรสนับสนุนให้เข้า MSCI ESG';
			case 'C':
				return 'บจ. ที่ควรสนับสนุนให้เข้า DJSI';
			case 'D':
				return 'บจ. ที่ควรสนับสนุนให้เข้า MSCI ESG และ DJSI';
			case 'E':
				return 'บจ. ที่ควรสนับสนุนให้เข้า MSCI standard, MSCI ESG และ DJSI';
			case 'F':
				return 'บจ. ที่ควรสนับสนุนให้เข้า MSCI standard, MSCI ESG และ DJSI';
			case 'G':
				return 'บจ. ที่ควรสนับสนุนให้เข้า DJSI';
		}
	}

	isSector() {
		if (this.type === 'sector') {
			return true;
		}
		return false;
	}

	isSymbol() {
		if (this.type === 'symbol') {
			return true;
		}
		return false;
	}

	isCompany() {
		if (this.type === 'company') {
			return true;
		}
		return false;
	}

	ngOnDestroy() {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}

	printFullFactsheet() {
		const service = this.cpmService;
		const encodeSymbol = encodeURIComponent(this.securitySymbol);
		service.downloadFile(`${environment.cpmBaseUrl}/pdf/fullfactsheet?symbol=${encodeSymbol}&period=YTD`);
	}
	checkIsZeroOrNull(value) {
		if (value === 0 || value === null) {
			return true;
		} else {
			return false;
		}
	}
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/company-header/company-header.component.ts